import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { PdfTemplateEditorPage } from "@/components/pdf-templates/pdf-template-editor-page";
import type { Id } from "@/convex/_generated/dataModel";

// `/settings/pdf-templates/new?target=invoices` crea; `/settings/pdf-templates/<id>` edita.
const searchSchema = z.object({ target: z.string().optional() });

export const Route = createFileRoute("/_authenticated/settings/_layout/pdf-templates/$templateId")({
  validateSearch: searchSchema,
  component: PdfTemplateDetailPage,
});

function PdfTemplateDetailPage() {
  const { templateId } = Route.useParams();
  const { target } = Route.useSearch();
  const id = templateId === "new" ? null : (templateId as Id<"pdf_templates">);

  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
        <PdfTemplateEditorPage templateId={id} newTarget={target} />
      </div>
    </RouteGuardPermissions>
  );
}
